export default (file: File | MediaAsset) => {
  return isFile(file) ? file.type.split('/')[0] : file.asset_type;
};
